import { INHOUSE_MESSAGE_TYPE, Overwrite } from './../common';
import { UploadEnquiryInfoBizContentType } from '@shopee/shopee-chatbot-agent-chat/dist/types';

export type UploadEnquiryInfoBizContent = UploadEnquiryInfoBizContentType & {
  inbound_order_sn?: string;
  userTypeName?: string;
  inhouseEnquiryTypeName?: string;
  csFillDatas?: Record<string, any>;
  startSessionParams?:Record<string, any>;
  user_type_label?: string;
}
export interface HistoryItem {
  message_id: string;
  session_id: string;
  dialogue_id: string;
  /** 消息发送时间 */
  send_time: number;
  /** 后端解析不成功 */
  is_nonsupport: boolean;
  /** 平台消息类型 */
  msg_type: HISTORY_MESSAGE_TYPE;
  /** 消息来源 */
  sender: HISTORY_MESSAGE_FROM;
  /** 消息内容 */
  content: UserSendHistory | ChatbotSendHistory | SaleforceHistory | InhouseHistory | ParseInhouseHistory;
}

// 用户发送的消息
export interface UserSendHistory {
  /** 消息类型 */
  type: USER_SEND_TYPE;
  /** 消息内容 */
  text?: string;
  /** transaction相关信息 */
  transaction_select_withdrawl?: any;
  transaction_select_topup?: any;
  /** order相关信息 */
  order_select?: any;
  /** 用户发送给saleforce的 */
  params?: any;
  /** case 相关信息 */
  case_select?: any;
}

// chatbot发送的消息
export interface ChatbotSendHistory {
  reply_type: number;
  message: any;
  message_extra: any;
}

// 与SF聊天时的消息
export interface SaleforceHistory {
  /** 消息类型 */
  type: string;
  /** 客服发送的消息才有 */
  message?: any;
  chatbot_ext?: any;
  text?: any;
  params?: any;
}

// 与inhouse聊天时的消息
export type InhouseHistory = {
  content: string;
  ctime: number;
  msg_flow: number; // inhouse的消息流向，服务端生成; 历史消息中没有
  msg_type: INHOUSE_MESSAGE_TYPE;
  seq_id: string | number;
  msg_id: string;
  user_type: UserType;
};

export interface InhouseHistoryContent {
  entry_point?: string;
  session_id?: string;
  text?: string;
  url?: string; // 高清原始图片, 文件 url 地址
  thumbnail?: string; // 图片的缩略图
  filename?: string;
  name?: string;
  size?: number; // 500KB
  duration?: number;

  // for CS_JOINED
  cs_name?: string;
  cs_id?: string;
  is_transfer?: boolean;

  // for QUEUING
  number?: number;
  estimated_wait_time?: number;

  // for SESSION_TRANSFER
  tar_cs_name?: string;
  // order_select?: OrderParams;
  order_id?: number,
  order_sn?: string,
  shop_id?: number,
  order_name?: string,
  price?: string,
  specification?: string,
  image?: string,
  checkout_id?: number,
  uri_key?: string,

  // for CHASING_START_MSG or INCOMPLETE_START_MSG
  countdown?: string,

  notice_msg?: string,
  variables?: string; // json string ,  用于包含notice_msg 中的变量
  type?: string;
  buttons?: {
    button_type?: number; // 按钮类型， enum: 1=url, 2=reply msg
    button_msg?: string;
    url?: string; // 当 button_type =1， url 有效
    reply_msg?: string; // 当 button_type =1=2， reply_msg 有效
    action_type?: number; // 按钮操作类型： 1=继续进线
    variables?: string; // json string ,  用于包含button_msg 中的变量
  }[],
}

interface OrderParams {
  order_id: number,
  order_sn: string,
  shop_id: number,
  order_name: string,
  price: string,
  specification: string,
  image: string,
  checkout_id: number,
  uri_key: string
}

export type ParseInhouseHistory = Overwrite<InhouseHistory, {
  content: InhouseHistoryContent
}>;

export enum UserType {
  Anonymous = 101,
  Seller = 102,
  Buyer = 103,
  Premium = 104,
  // 机器人，仅用于 chatbot 历史消息数据上传到 InHouseCS 的场景
  BOT = 200,
  // 人工客服
  LocalCS = 201,
  SERVICE_ASSISTANT = 202,
}

// 历史消息状态
export enum HISTORY_STATUS {
  HAS_MORE_HISTORY,
  NO_MORE_HISTORY,
  NO_MORE_HISTORY_IN_180_DAYS
}

export enum NO_MORE_REASON {
  NO_MORE_HISTORY,
  NO_MORE_HISTORY_IN_180_DAYS
}

// 平台消息类型
export enum HISTORY_MESSAGE_TYPE {
  SALE_FORCE = 1,
  IN_HOUSE,
  CHATBOT
}

// 消息来源
export enum HISTORY_MESSAGE_FROM {
  USER = 1,
  CHATBOT,
  AGENT
}

// 用于落库历史消息给后端的type
export enum USER_SEND_TYPE {
  TEXT = 'TEXT',
  TRANSACTION_SELECT_TOPUP = 'TRANSACTION_SELECT_TOPUP',
  TRANSACTION_SELECT_WITHDRAWL = 'TRANSACTION_SELECT_WITHDRAWL',
  ORDER_SELECT = 'ORDER_SELECT',
  FILE = 'FILE',
  IMG = 'IMG',
  VID = 'VID',
  ORDER = 'ORDER',
  CASE_SELECT = 'CASE_SELECT',
}

export interface HistoryData {
  no_more_reason: NO_MORE_REASON;
  has_more: boolean;
  messages: Array<any>;
}
